import React from 'react';
import { useIntl } from 'react-intl';
/*********************************************************
 * Controls
 *********************************************************/
import styles from 'Assets/sass/core/vars.scss';

/*********************************************************
 * Icons
 *********************************************************/
import LandmarkMarkerSvg from './IconsSvg/LandmarkMarkerSvg'
import GeofenceSvg from './IconsSvg/GeofenceSvg';

import { vidFleetVideoEvents, lightMetricEvents, switnessVideoEvents } from "../../../core/data/VideoEvents";
import { filter } from 'jszip';

export const getLegends = () => {
  const { messages } = useIntl();
  let legends = [
    {
      id: "Drive",
      isControl: false,
      name: messages["realtimemaps_drive"],
      color: styles.color_evnt_drive,
    },
    {
      id: "Drive",
      isControl: false,
      name: messages["realtimemaps_motion"],
      color: styles.color_evnt_drive,
    },
    {
      id: "Travel Start",
      isControl: false,
      name: messages["realtimemaps_motion_start"],
      color: styles.color_evnt_travel_start,
    },
    {
      id: "Travel Stop",
      isControl: false,
      name: messages["realtimemaps_motion_stop"],
      color: styles.color_evnt_travel_stop,
    },
    {
      id: "Ignition Off",
      isControl: false,
      name: messages["realtimemaps_ignitionOff"],
      color: styles.color_evnt_ignition_off,
    },
    {
      id: "Ignition On",
      isControl: false,
      name: messages["realtimemaps_ignitionOn"],
      color: styles.color_evnt_ignition_on,
    },
    {
      id: "Travel Start",
      isControl: false,
      name: messages["realtimemaps_travelStart"],
      color: styles.color_evnt_travel_start,
    },
    {
      id: "Travel Stop",
      isControl: false,
      name: messages["realtimemaps_travelStop"],
      color: styles.color_evnt_travel_stop,
    },
    {
      id: "Geofence In",
      isControl: false,
      name: messages["realtimemaps_geofenceIn"],
      color: styles.color_evnt_geofence_in,
    },
    {
      id: "Geofence Out",
      isControl: false,
      name: messages["realtimemaps_geofenceOut"],
      color: styles.color_evnt_geofence_out,
    },
    {
      id: "Idle",
      isControl: false,
      name: messages["realtimemaps_idle"],
      color: styles.color_evnt_idle,
    },
    {
      id: "Stop",
      isControl: false,
      name: messages["realtimemaps_stop"],
      color: styles.color_evnt_stop,
    },
    {
      id: "Parked",
      isControl: false,
      name: messages["realtimemaps_parked"],
      color: styles.color_evnt_parked,
    },
    {
      id: "Update",
      isControl: false,
      name: messages["realtimemaps_update"],
      color: styles.color_evnt_update,
    },
    {
      id: "Sudden Stop",
      isControl: false,
      name: messages["realtimemaps_suddenStop"],
      color: styles.color_evnt_sudden_stop,
    },
    {
      id: "Rapid Acceleration",
      isControl: false,
      name: messages["realtimemaps_rapidAcceleration"],
      color: styles.color_evnt_rapid_acceleration,
    },
    {
      id: "Hard Brake",
      isControl: false,
      name: messages["realtimemaps_hardBrake"],
      color: styles.color_evnt_hard_brake,
    },
    {
      id: "Hard Turn",
      isControl: false,
      name: messages["realtimemaps_hardTurn"],
      color: styles.color_evnt_hard_turn,
    },
    {
      id: "Other",
      isControl: false,
      name: messages["realtimemaps_other"],
      color: styles.color_evnt_other,
    },
    {
      id: "Landmark",
      isControl: true,
      name: messages["realtimemaps_landmark"],
      control: <LandmarkMarkerSvg color={styles.color_evnt_drive} />,
    },
    {
      id: "Geofence",
      isControl: true,
      name: messages["realtimemaps_geofence"],
      control: <GeofenceSvg />,
    },
    {
      id: "Offline",
      isControl: true,
      name: messages["realtimemaps_offline"],
      control: (
        <img
          src="/assets/icons/offlineimage.png"
          style={{ width: 20, height: 20, position: 'relative' }}
          alt="offline"
        />
      ),
    },
  ];

  return legends;
};

export const getTrailsLegends = () => {
  const { messages } = useIntl();
  let legends = getLegends();

  // Transform video events into legend format
  const videoEventsArray = [
    ...Object.values(vidFleetVideoEvents),
    ...Object.values(lightMetricEvents),
    ...Object.values(switnessVideoEvents)
  ].map((event) => {
    const label = `${messages[event?.lanKey] || (event.name === "Crash" ? messages["videoMainView_drivingHit"] : event.name)}`;

    return {
      id: event.name,
      isControl: false,
      name: label,
      color: event.color,
      icon: event.icon,
      filterable: true,
    };
  });

  // Combine legends with video events
  const combined = [...legends, ...videoEventsArray];

  // Remove duplicates based on id/name
  const uniqueMap = new Map();
  combined.forEach(item => {
    const key = item.id || item.name;
    if (!uniqueMap.has(key)) {
      uniqueMap.set(key, item);
    }
  });

  return Array.from(uniqueMap.values());
}
